import(/* webpackMode: "eager" */ "/app/src/app/politicas-privacidad/page.jsx");
